// extracted by mini-css-extract-plugin
module.exports = {"share-body":"share-popup_share-body__6p67Y"};